import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Row } from '../../../../../components/Basic/Blocks';
import { Input } from '../../../../../components/Basic/Inputs';
import ReserveStepper from './Stepper';
import styles from './styles.module.scss';

const ReserveStepperInput = ({ item = {}, ...props }) => {
  const [data, setData] = useState({});

  const skladName = useSelector(store => store.ui.skladName.short_name)


  useEffect(() => {
    setData(item);
  }, [item]);
  return (
    <>
      <Row>
        <Input
          value={data?.sklad_data?.[skladName]?.shipment_reserved + data?.sklad_data?.[skladName]?.hand_reserved}
          fontSize="14px"
          textAlign="center"
          width={'35px'}
          readOnly
          styles={styles.bold_input}
          style={{ marginRight: '15px', fontWeight: 600 }}
        />
        <ReserveStepper item={data} save={(v) => setData(v)} skladName={skladName}/>
      </Row>
    </>
  );
};

export default ReserveStepperInput;
